import { render, staticRenderFns } from "./FormProfession.vue?vue&type=template&id=7abfff0a"
import script from "./FormProfession.vue?vue&type=script&lang=js"
export * from "./FormProfession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports